module.exports = __webpack_public_path__ + "static/img/15.2b4a3ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/15.png
// module id = 88AI
// module chunks = 0